module.exports = __webpack_public_path__ + "img/word_template.84e26bb7.jpg";